import { SvgIcon } from "@mui/material";

export default function ResourcesIcon() {
	return (
		<SvgIcon>
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				d="m12 3l9 4.5l-9 4.5l-9-4.5L12 3Zm4.5 7.25L21 12.5L12 17l-9-4.5l4.5-2.25m9 5L21 17.5L12 22l-9-4.5l4.5-2.25"
			/>
		</SvgIcon>
	);
}
